module.exports = __webpack_public_path__ + "media/packs/images/flags/TT-dd7590e84b8e3884dbc0a0a6aff1765a.svg";